const { CACHE_ENABLED } = process.env;

function buildUrl(url, method, params) {
	if (method !== 'GET' || !params || Object.keys(params).length === 0) {
		return url;
	}

	const queryString = new URLSearchParams(params).toString();
	return url + (url.includes('?') ? '&' : '?') + queryString;
}

function isFileArray(value) {
	return Array.isArray(value) && value.every((item) => item instanceof File);
}

function paramsHasFiles(params) {
	return Object.values(params).some((v) => v instanceof File || isFileArray(v));
}

function buildPayload(params) {
	const formData = new FormData();
	const payload = {};
	for (const name in params) {
		if (isFileArray(params[name])) {
			for (const file of params[name]) {
				formData.append(`${name}[]`, file);
			}
		} else if (params[name] instanceof File) {
			formData.append(name, params[name]);
		} else {
			payload[name] = params[name];
		}
	}

	return { formData, payload };
}

function buildInit(method, params, options) {
	const { tags, ...restOptions } = options;

	const init = {
		method,
		headers: {
			Accept: 'application/json',
		},
		next: { revalidate: 0 },
		...restOptions,
	};

	if (method === 'GET') {
		init.next = {
			revalidate: CACHE_ENABLED === 'true' ? 60 * 60 * 24 * 356 : 0,
			tags: tags ?? [],
			...restOptions.next,
		};
		return init;
	}

	const hasFiles = paramsHasFiles(params);

	if (!hasFiles) {
		init.body = JSON.stringify(params);
		console.log(init.body);
		return init;
	}

	const { formData, payload } = buildPayload(params);

	formData.append('payload', JSON.stringify(payload));
	init.body = formData;

	return init;
}

export const request = async (url, method, params = {}, options = {}) => {
	const finalUrl = buildUrl(url, method, params);
	const init = buildInit(method, params, options);
	const res = await fetch(finalUrl, init);
	const data = await res.json().catch(() => ({}));
	return { data, status: res.status };
};
